module.exports = __webpack_public_path__ + "static/media/AkkuratLight.a8c40109.svg";